export default __webpack_public_path__ + "static/media/DueColorIcon.cc6c6b41.svg";